// import { EventPlayThemeWrapper } from "../components/EventPlayThemeWrapper";

import { Stack, useMantineTheme } from "@mantine/core";
import { EventHeader } from "../components/EventHeader";
import { Footer } from "../components/Footer";
import { useParams } from "react-router-dom";
import { useGetEventQuery } from "event/api/event.api";

export function FoodMenuV2() {
  const theme = useMantineTheme();
  const { eventId } = useParams<{ eventId: string }>();
  const { data } = useGetEventQuery(eventId as string);

  return (
    <div style={{ fontFamily: theme.fontFamily }}>
      <Stack
        className="min-h-screen justify-start"
        justify="center"
        align="center"
      >
        <EventHeader />

        {/* Container to hide iframe scrollbar */}
        <div
          style={{
            width: "100%",
            height: "80vh",
            overflow: "hidden",
            position: "relative",
          }}
        >
          <iframe
            src={data?.food_menu_v2_url}
            style={{
              width: "100%", // Slightly wider to hide scrollbar
              height: "100%",
              border: "none",
              position: "absolute",
              top: 0,
              left: 0,
            }}
            title="Food Menu"
            allow="payment; camera; microphone;fullscreen"
          />
        </div>
      </Stack>
      <Footer />
    </div>
  );
}

export default FoodMenuV2;
